module.exports = __webpack_public_path__ + "static/media/biglow-woodcraft.f32d7452.jpg";